
// region JS Imports

// region External Modules
import $ from "jquery"

import serialize from "form-serialize"
// endregion External Modules

// region Private Modules
import * as Routes from "plugins/js-routes"
import I18n from "plugins/i18n-js"

import Modal from "app/modal/show-modal"
import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"
// endregion Private Modules

// region Public Components
import {
  FollowTypes,
} from "app/resources/building_followings/subscribe"

import Notifier from "app/notifier/index"
// endregion Public Components

// region Private Components
import ConfirmCancelFollowModal from "./confirm_cancel_follow_modal"
// endregion Private Components

// endregion JS Imports



interface Input {
  user_authentication_handle: string,

  building_id: string | number,

  follow_type: FollowTypes,
}

const update_follow_record = () => {
  const $form = $(".cell--buildings--follow-type-select-modal--desktop_ver--form")

  const form_data = serialize($form[0] as HTMLFormElement, { hash: true }) || {}

  const form_url_path = $form.attr("action") || ""
  q_ajax_3({
    url:      form_url_path,
    method:   "POST",
    dataType: "html",

    // Sending JSON to server
    contentType:  "application/json; charset=utf-8",
    data:         JSON.stringify(form_data),
  })
}

const init = ({user_authentication_handle, building_id, follow_type}: Input) => {
  q_ajax_3({
    url:      Routes.apps_spacious_website_partials_buildings_follow_type_select_modal_path(
      {
        locale:                     I18n.locale,
        building_id:                building_id,
        follow_type:                follow_type,
        user_authentication_handle: user_authentication_handle,
      },
    ),
    method:   "GET",
    dataType: "html",
  })
  .then(({data}) => {
    Modal.hideTopModal()
    Modal.showModalWithContent(data, {
      class: "container",
    })

    let checked_count = $(".cell--buildings--follow-type-select-modal--desktop_ver--form").find("input[type=\"checkbox\"]").length

    $(".slide-toggle").on("click", (e) => {
      const $checkbox = $(e.target).siblings("input[type='checkbox']")
      let isChecked = $checkbox.prop("checked")

      // Prevent toggling the last checked option (require confirmation)
      if (checked_count === 1 && isChecked) {
        ConfirmCancelFollowModal.init({ user_authentication_handle, building_id, follow_type })
        return
      }

      // Toggle the checked state
      $checkbox.prop("checked", !isChecked)

      isChecked = !isChecked

      const alert_message = isChecked? $checkbox.data("follow-message") : $checkbox.data("unfollow-message")
      Notifier.showSpaciousBlackAlert(alert_message, 5000)

      // Update the checked_count based on the new state
      checked_count += (isChecked ? 1 : -1)

      update_follow_record()
    })

    $(".cell--buildings--follow-type-select-modal-content-cancel-button").on("click", () => {
      Modal.hideAllModals()
    })

    $(".cell--buildings--follow-type-select-modal-content-confirm-button").on("click", () => {
      Modal.hideAllModals()
    })

  })
}


export default {init}
